/**************************************************************************************************/
/*   File: /src/app/shared/shared.module.ts                                                       */
/*   Project: newplan-frontend                                                                    */
/*   Created Date: Friday February 22nd 2019                                                      */
/*   Author: Andrea Zamboni andrea.zamboni@trilogis.it                                            */
/*   -----                                                                                        */
/*   Last Modified: Wed Jul 31 2019                                                               */
/*   Modified By: Andrea Zamboni                                                                  */
/*   -----                                                                                        */
/*   Copyright (c) 2019 Trilogis s.r.l. for SIAG                                                  */
/**************************************************************************************************/
import { LoggerModule, NgxLoggerLevel } from 'ngx-logger';
import { MomentModule } from 'ngx-moment';
import { HTTP_INTERCEPTORS } from '@angular/common/http';

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

import { environment } from '../../environments/environment';
import * as fromComponents from './components';
import * as fromDirectives from './directives';
import * as fromInterceptors from './interceptors';

/**
 * The component module
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    MomentModule,
    LoggerModule.forRoot({ level: environment.logLevel })
  ],
  entryComponents: [
    fromComponents.NumberComponent,
    fromComponents.ExpanderComponent,
    fromComponents.ConfirmDialogComponent
  ],
  declarations: [
    fromComponents.LoaderComponent,
    fromComponents.MessageBoxComponent,
    fromComponents.FileUploaderComponent,
    fromComponents.UploadFieldComponent,
    fromComponents.UploadBodyComponent,
    fromComponents.UploadPreviewComponent,
    fromComponents.MapComponent,
    fromComponents.BreadcrumbComponent,
    fromComponents.MessagesComponent,
    fromComponents.FlagComponent,
    fromComponents.IFrameComponent,
    fromComponents.PlanTypeSelectorComponent,
    fromComponents.AmbitoSelectorComponent,
    fromComponents.FileTypeSelectorComponent,
    fromComponents.HomepageComponent,
    fromComponents.NumberComponent,
    fromComponents.DossierTypeComponent,
    fromComponents.ExpanderComponent,
    fromDirectives.FileUploadDirective,
    fromDirectives.DragAndDropDirective,
    fromDirectives.WizardCardDirective,
    fromDirectives.RowExpanderDirective,
    fromComponents.ConfirmDialogComponent
  ],
  exports: [
    fromComponents.LoaderComponent,
    fromComponents.MessageBoxComponent,
    fromComponents.FileUploaderComponent,
    fromComponents.MapComponent,
    fromComponents.BreadcrumbComponent,
    fromComponents.MessagesComponent,
    fromComponents.FlagComponent,
    fromComponents.IFrameComponent,
    fromComponents.PlanTypeSelectorComponent,
    fromComponents.AmbitoSelectorComponent,
    fromComponents.FileTypeSelectorComponent,
    fromComponents.HomepageComponent,
    fromComponents.NumberComponent,
    fromComponents.ExpanderComponent,
    fromComponents.DossierTypeComponent,
    fromDirectives.WizardCardDirective,
    fromDirectives.RowExpanderDirective,
    fromComponents.ConfirmDialogComponent
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: fromInterceptors.CacheInterceptor, multi: true }
  ]
})
export class SharedModule { }
